import React from 'react';
import {FormDialog} from 'components/core';
import {ItemPreview} from 'components/procedures/items';
import {ProcedureItemsCtx} from 'components/dataProviders/procedureItems';
import IconSelector from 'components/procedures/iconSelector';


export default function ItemDialog({open, handleClose=()=>{}, onConfirm=()=>{}, itemID=null})
{
    const [loading, setLoading] = React.useState(false);
    const [categories, setCategories] = React.useState([{value: 0, content: "Sin categoría"}]);
    const [types, setTypes] = React.useState([]);
    const [previewData, setPreviewData] = React.useState({color: "333333", iconText: "", typeID: 1, iconID: -1});
    const [values, setValues] = React.useState({name: '', typeID: 1, iconID: -1, color: '333333', iconText: '', description: '', categoryID: 0});
    const itemsCtx = React.useContext(ProcedureItemsCtx);

    
    React.useEffect(function clearOnClose(){
      if(!open){
        setValues({name: '', typeID: 1, iconID: -1, color: '333333', iconText: '', description: '', categoryID: 0});
        setPreviewData({color: "333333", iconText: "", typeID: 1, iconID: -1});
      }
    }, [open]);

    React.useEffect(function initializeSelectors() {
      let tmpTypes = [];
      let tmpCategories = [{value: 0, content: "Sin categoría"}];
      itemsCtx.itemTypes.array.forEach((item) => tmpTypes.push({value: item.typeID, content: item.name}));
      itemsCtx.categories.data.array.forEach((item) => tmpCategories.push({value: item.categoryID, content: item.name}));
      setCategories(tmpCategories);
      setTypes(tmpTypes);
  }, [itemsCtx]);

  React.useEffect(function initializeValues() {

    if(itemID === null) return; // create mode

    if(itemsCtx.items.indexed[itemID])
    {
        setValues(itemsCtx.items.indexed[itemID]);
        setPreviewData(itemsCtx.items.indexed[itemID]);
    }
}, [itemsCtx, itemID]);

    const handleConfirm = (values) => {
      setLoading(true);
      if(values.categoryID === 0) values.categoryID = null;
      if(values.typeID === 0) values.typeID = 1;

      function apiCallback() {
        setLoading(false);
        onConfirm();
        handleClose();
      };
      if(itemID !== null) itemsCtx.funcs.update(itemID, values).then(apiCallback);
      else itemsCtx.funcs.create(values).then(apiCallback);
    }

    const handleDialogChange = (newValues) => {

      if(!newValues.iconID) newValues.iconID = -1;
      else newValues.iconID = parseInt(newValues.iconID);
      newValues = {...values, ...newValues};
      setValues(newValues);
      setPreviewData(newValues);
    }

    const handleIconChange = (iconID) => {
      let tmpValues = {...values, iconID: iconID};
      setValues(tmpValues);      
      setPreviewData(tmpValues);
    }


    const fields = [
      {
        type: "text",
        label: "Nombre",
        id: "name",
        placeholder: "Nombre del item",
        mandatory: true
      },
      {
        type: "selector",
        label: "Tipo de item",
        id: "typeID",
        items: types
      },
      {
        type: "custom",
        label: "Previsualización",
        id: "preview",
        content: <><ItemPreview {...previewData} /></>
      },
      {
        type: "custom",
        label: "Icono",
        id: "icon",
        content: <><IconSelector iconID={values.iconID} onChange={handleIconChange} /></>
      },
      {
        type: "colorPicker",
        id: 'color',
        label: "Color"
      },
      {
        type: "text",
        label: "Texto del item",
        id: "iconText",
        placeholder: "p.e. \"No tocar\"",
      },
      {
        type: "textarea",
        label: "Descripción",
        id: "description",
        placeholder: "",
        mandatory: false,
      },
      
      {
        type: "selector",
        label: "Categoría",
        id: "categoryID",
        items: categories
      }
    ];

    return <FormDialog
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onChange={handleDialogChange}
      title={itemID === null ? "Nuevo Item" : "Editar item"}
      confirm={itemID === null ? "Crear Item" : "Guardar"}
      cancel="Cancelar"
      loading={loading}
      fields={fields}
      values={values}
      />
}
